import { Component, h } from 'preact'
import Checkbox from '../../ui-components/Checkbox'
import Attachments from '../../category/control/Attachments'
import { DropdownSelectizeInput } from '../../dropdown/DropdownSelectize'
import PublicTagSelect from '../../public-tag/PublicTagSelect'
import ProductAreaSelect, { ProductAreaType } from '../../product-areas/ProductAreaSelect'
import { common } from '../../common'
import { CONTENT_TYPE_PRODUCT_UPDATE } from '../../utils/contentType'
import PreviewSettings from '../../create-topic-page/PreviewSettings'

interface Props {
  allowReplies: boolean,
  sticky: boolean,
  featuredImage: string | null,
  tags: string[] | null,
  onUpdate: (field: string, value: any) => void,
  topicId?: number | null,
  onError: () => void,
  onSuccess: (message: string) => void,
  canEndUserAddPublicTags: boolean,
  allProductAreas: Array<ProductAreaType>,
  selectedProductAreas: Array<ProductAreaType>,
  onUpdateProductAreas: (selectedItems: Array<ProductAreaType>) => void,
  onShowPreviewModal: () => void,
  isPreviewPublic: boolean | null,
  labels: string[],
  publicLabel: string | null
}

export default class Sidebar extends Component<Props> {
  private isPublicTagManagementEnabled:boolean = common.isModuleActive('publicTagManagement')
  private isProductAreasEnabled:boolean = common.isModuleActive('productAreas')
  render ({
            topicId,
            allowReplies,
            featuredImage,
            tags,
            onUpdate,
            canEndUserAddPublicTags,
            allProductAreas,
            selectedProductAreas,
            onUpdateProductAreas,
            isPreviewPublic,
            onError,
            onSuccess,
            labels,
            publicLabel,
            onShowPreviewModal
          }: Props) {

    return (
      <div class='topic-creator__sidebar category-add_container'>
        { topicId && <PreviewSettings
          type={CONTENT_TYPE_PRODUCT_UPDATE}
          topicId={topicId}
          isPublic={isPreviewPublic || false}
          onShowPreviewModal={onShowPreviewModal}
          onError={onError}
          onSuccess={onSuccess} />
        }
        <div class='form-group'>
          <Checkbox
            label='Allow replies'
            onUpdate={status => onUpdate('open', status)}
            qaClasses='qa-open'
            checked={allowReplies}
          />
        </div>
        <div className='form-group'>
          <label for='product-update-label'>Product Update Label</label>
          <DropdownSelectizeInput
            single
            items={labels}
            class='js-public-label js-field form-control selectize-allow-input qa-public-label'
            placeholder='Add a label next to product update title'
            selectedItem={publicLabel || this.props.publicLabel || ''}
            onChange={(label: string) => onUpdate('publicLabel', label)}
            allowEmptyValue
          />
        </div>
        <Attachments
          label='Featured Image'
          className='topic-creator__sidebar-featured-image'
          meta={<div>Maximum file size: 5M. Allowed image types: .jpg, .jpeg, .png, .gif. We recommend a minimum of 1440*640px</div>}
          isAttachmentSelected={featuredImage !== ''}
          imageSrc={featuredImage || null}
          width={1440}
          height={640}
          onUpdate={(data: undefined | {source_thumb: string}) => onUpdate('featuredImage', data ? data.source_thumb : null)}
        />
        {
          this.isProductAreasEnabled && allProductAreas.length ? (
            <div className='form-group'>
              <label>Product Areas</label>
              <ProductAreaSelect
                allProductAreas={allProductAreas}
                selectedProductAreas={selectedProductAreas}
                onUpdate={onUpdateProductAreas}
              />
            </div>
          ) : null
        }
        {
          this.isProductAreasEnabled && tags !== null ? (
            <div className='form-group'>
              <label for='public-tags-label'>Public Tags</label>
              {this.isPublicTagManagementEnabled
                ? <PublicTagSelect
                  isEdit={false}
                  onChange={(tags) => onUpdate('tags', tags)}
                  selectedPublicTags={tags.join(',')}
                  inputName='form-control qa-topic-creator-public-tags-input'
                  canEndUserAddPublicTags={canEndUserAddPublicTags}
                  iconSize={12}/>
                : <DropdownSelectizeInput
                  items={[]}
                  single={false}
                  class='form-control qa-topic-creator-public-tags-input'
                  placeholder='Add tags to help readers easily find this product update'
                  selectedItems={tags && tags.length ? tags : (tags || [])}
                  onChange={(tags) => onUpdate('tags', tags)}/>
              }
            </div>
          ) : null
        }
      </div>
    )
  }
}
